import Handlebars from 'handlebars';

Handlebars.registerHelper('toJSON', function (object) {
  var str = new Handlebars.SafeString(JSON.stringify(object));
  if (str && str.string) {
    var results = str.string.match(/\[.*?\]/g);
    if (results) {
      for (var i = 0; i < results.length; i += 1) {
        var val = results[i];
        str.string = str.string.replace(val, '');
      }
    }
  }
  return str;
});
